import { Component, OnInit, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { environment } from '../core/environment';

interface Sport {
  id: string;
  name: string;
  code: string;
  description?: string;
  isActive: boolean;
}

@Component({
  selector: 'app-masters',
  standalone: true,
  imports: [ReactiveFormsModule],
  template: `
    <div class="page-header">
      <div>
        <h2>Masters</h2>
        <p>Sports, batches, levels, plans, and operational setup.</p>
      </div>
    </div>

    <section class="split-grid">
      <form class="panel form-panel" [formGroup]="sportForm" (ngSubmit)="createSport()">
        <h3>Sports Master</h3>
        <label>Name <input formControlName="name"></label>
        <label>Code <input formControlName="code"></label>
        <label>Description <textarea formControlName="description"></textarea></label>
        <button class="primary-action" type="submit" [disabled]="sportForm.invalid">Add Sport</button>
      </form>

      <article class="panel">
        <h3>Active Sports</h3>
        <table>
          <thead><tr><th>Code</th><th>Name</th><th>Status</th></tr></thead>
          <tbody>
            @for (sport of sports(); track sport.id) {
              <tr>
                <td>{{ sport.code }}</td>
                <td>{{ sport.name }}</td>
                <td><span class="status-chip">{{ sport.isActive ? 'Active' : 'Inactive' }}</span></td>
              </tr>
            }
          </tbody>
        </table>
      </article>
    </section>
  `
})
export class MastersComponent implements OnInit {
  private readonly http = inject(HttpClient);
  private readonly fb = inject(FormBuilder);
  readonly sports = signal<Sport[]>([]);
  readonly sportForm = this.fb.nonNullable.group({
    name: ['', Validators.required],
    code: ['', Validators.required],
    description: ['']
  });

  ngOnInit(): void {
    this.load();
  }

  createSport(): void {
    if (this.sportForm.invalid) return;
    this.http.post<Sport>(`${environment.apiUrl}/masters/sports`, { ...this.sportForm.getRawValue(), isActive: true }).subscribe(() => {
      this.sportForm.reset();
      this.load();
    });
  }

  private load(): void {
    this.http.get<Sport[]>(`${environment.apiUrl}/masters/sports`).subscribe((items) => this.sports.set(items));
  }
}
